module.exports = "../../static/img/newlogo.6ae10e5.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/newlogo.jpg
// module id = 928
// module chunks = 2